/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIArticleFile } from './APIArticleFile';
import {
    APIArticleFileFromJSON,
    APIArticleFileFromJSONTyped,
    APIArticleFileToJSON,
} from './APIArticleFile';

/**
 * 
 * @export
 * @interface APIPaginatedArticleFileList
 */
export interface APIPaginatedArticleFileList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedArticleFileList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleFileList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedArticleFileList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIArticleFile>}
     * @memberof APIPaginatedArticleFileList
     */
    results: Array<APIArticleFile>;
}

/**
 * Check if a given object implements the APIPaginatedArticleFileList interface.
 */
export function instanceOfAPIPaginatedArticleFileList(value: object): value is APIPaginatedArticleFileList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedArticleFileListFromJSON(json: any): APIPaginatedArticleFileList {
    return APIPaginatedArticleFileListFromJSONTyped(json, false);
}

export function APIPaginatedArticleFileListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedArticleFileList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIArticleFileFromJSON)),
    };
}

export function APIPaginatedArticleFileListToJSON(value?: APIPaginatedArticleFileList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIArticleFileToJSON)),
    };
}

